<div class="panel panel-default nopadding">
  <div class="panel-title">
    Open Exception Details
  </div>
  <div class="panel-body nopadding" style="height:520px!important;overflow-y:scroll !important;">
    <div class=nopadding>
      @if(isLoadingResults){
      <div class="example-loading-shade">
        @if(isLoadingResults){
        <mat-spinner>Loading...</mat-spinner>
        }
      </div>
      }
      <table mat-table class="highlight" #table [dataSource]="dataSource" matSort matSortActive="count"
        matSortDirection="desc">
        <!-- Dynamic      -->
        @for(col of displayedColumns; track col){
        <ng-container matColumnDef={{col}}>

          @if(col === 'count'){
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-weight: bold;">{{col.replace('_', ' ') |
            titlecase }} </th>
          } @else {
          <th mat-header-cell *matHeaderCellDef mat-sort-header
            style="font-weight: bold; width: 150px !important; padding-right:0;">{{col.replace('_', ' ') | titlecase }}
          </th>
          }
          @if(col === 'count'){
          <td mat-cell *matCellDef="let Exception">
            <span>{{Exception[col]}}</span>
          </td>
          } @else{
          <td mat-cell *matCellDef="let Exception">
            @if(col==='exception_Code'){
            <span>
              <a [routerLink]=redirectUrl routerLinkActive="activeRoute" (click)="setMenu(Exception[col])"
                (mouseover)="Route(Exception[col])">{{Exception[col]}} </a>
            </span>
            }
            @if(col != 'exception_Code'){
            <span>{{Exception[col]}}</span>
            }
          </td>
          }
        </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator #paginator style="position:absolute; bottom: 0;" [pageSize]="rowcount"
        [pageSizeOptions]="[1,2,5,10,20,50,100]" [pageIndex]="currentPage" [length]="rowcount" showFirstLastButtons
        aria-label="Select page of periodic elements">
        (page)="pageChanged($event)"
      </mat-paginator>
    </div>
  </div>
</div>